<template>
  <div class="register-page">
    <div class="register-header">
      <img src="@/assets/imgs/invitationPage/biaoti@2x.png" alt="">
    </div>
    <div class="form-container">
      <div class="form-content">
        <div class="form-item">
          <input placeholder="请输入手机号" v-model="data.phone" type="tel" maxlength="11">
        </div>
        <div class="form-item sms">
          <input placeholder="请输入验证码" v-model="data.code" type="tel" maxlength="4">
          <button @click="getSms" v-if="showCode">获取验证码</button>
          <button v-else>{{counts}}s重新发送</button>
        </div>
        <div class="btn" @click="login">
          点击注册
        </div>
        <div class="protocol">
          <van-checkbox checked-color="#f2b054" v-model="checked" icon-size="13px"></van-checkbox>
          <p>请阅读并同意 <a href="https://protocol.imlaw.cn/lawyer_user_protocol.html?header=0">《法临注册协议》</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sendCode} from "@a";
import {login} from "@a/activity";
import {lawyerChannelBuryPv} from "@a/invitation";

export default {
  name: "register",
  data(){
    return{
      counts:60,
      showCode:true,
      checked:false,
      timerInterval:'',
      data:{
        phone:'',
        code:''
      }
    }
  },
  mounted() {
    lawyerChannelBuryPv({
      channelId:this.$route.query.lawyerChannel
    })
  },
  methods:{
    login(){
      let message = !this.data.phone && '请输入手机号！' ||
          !/^1\d{10}/.test(this.data.phone) && '输入手机号有误' ||
          !this.data.code && '请输入验证码！' ||
          !/\d{4}/.test(this.data.code) && '输入验证码有误' || null ||
          !this.checked && '请阅读并勾选《法临注册协议》' || null;
      if (message) return this.$toast(message);
      /**
       * inviteSource 3、律师端分享(inviteId) 2、营销人员分享(inviteSysUserId)
       */
      const inviteInfo={
        inviteId: this.$route.query.inviteId || this.$route.query.inviteSysUserId,  //分享id
        inviteSource:this.$route.query.inviteId ? 3:2
      }
      login({
        ...this.data,
        ...inviteInfo,
        lawyerChannel:this.$route.query.lawyerChannel
      },{
        headers:{
          osVersion:9
        }
      }).then(()=>{
        this.$router.push({
          path:'/invitation-page/registerSuccessTwo'
        })
      }).catch(({data})=>{
        if(data.code===1){
          setTimeout(()=>{
            this.$router.push({
              path:'/invitation-page/registerSuccessTwo'
            })
          },2000)
        }
      })
    },
    getSms(){
      let message = !this.data.phone && '请输入手机号！' ||
          !/^1\d{10}/.test(this.data.phone) && '输入手机号有误' || null
      if (message) return this.$toast(message)
      this.timer()
      sendCode({phone: this.data.phone}).then(res => {
        if (!res.code) {
          this.$toast('发送成功')
        }
      })
    },
    /* 倒计时*/
    timer() {
      if (!this.timerInterval) {
        this.counts = this.$options.data().counts
        this.showCode = false
        this.timerInterval = setInterval(() => {
          if (this.counts > 0) {
            this.counts--
          } else {
            this.clearTimer();
          }
        }, 1000)
      }
      this.$on('hook:destroyed', () => {
        this.clearTimer();
      })
    },
    clearTimer() {
      this.showCode = true
      clearInterval(this.timerInterval)
      this.timerInterval = null
    },
  }
}
</script>

<style scoped lang="scss">
.register-page{
  min-height: 100vh;
  background: url("~@/assets/imgs/invitationPage/bg@2x_two.png") no-repeat;
  background-size: 100% 100%;
  .register-header{
    padding-top: 49px;
    img{
      display: block;
      margin: 0 auto;
      width: 245px;
      height: 107px;
    }
    box-sizing: border-box;
    padding-bottom: 35px;
  }
  .form-container{
    background: url("~@/assets/imgs/invitationPage/xinfeng@2x.png") no-repeat;
    background-size: 100% 100%;
    height: 466px;
    .form-content{
      width: 301px;
      padding-top: 272px;
      margin: 0 auto;
      .form-item{
        height: 39px;
        border-radius: 22px;
        overflow: hidden;
        input{
          outline: none;
          text-indent: 27px;
          border: none;
          height: 100%;
          width: 100%;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .sms{
        display: flex;
        margin-top: 8px;
        justify-content: space-between;
        align-items: center;
        background: white;
        input{
          // width: auto;
          flex: 1;
        }
        button{
          width: 122px;
          font-size: 14px;
          border: none;
          font-weight: 400;
          color: #684528;
          background: none;
          outline: none;
          position: relative;
          &:after{
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 25px;
            background: #AAAAAA;
            content: " ";
          }
        }
      }

      .protocol{
        display: flex;
        align-items: center;
        padding-top: 11px;
        justify-content: center;
        p{
          padding-left: 4px;
          font-size: 13px;
          font-weight: normal;
          color: white;
          a{
            color: white;
          }
        }
      }

      .btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 301px;
        height: 39px;
        margin-top: 9px;
        background: linear-gradient(0deg, #F0A748, #FFE6AE);
        box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
        border-radius: 22px;
        font-size: 17px;
        font-weight: normal;
        color: #47180B;
      }
    }
  }
}
</style>
